import MessageCalendar from "../MessageCalendar";


const MessageCalendarSettings = () => {
    return (
        <MessageCalendar />
    )
}

export default MessageCalendarSettings